// ** Reducers
import layout from './layout'
import navbar from './navbar'
import auth from './authentication'
import location from './location'
import roles from './roles'
import permissions from './permissions'
import settings from './settings'
import notifications from './notification'

// ** Modules
import users from '@modules/User/Users/store'
import accountSettings from '@modules/AccountSettings/store'
import departments from '@modules/Department/Departments/store'
import products from '@modules/Product/Products/store'
import properties from '@modules/Product/Properties/store'
import suppliers from '@modules/Supplier/Suppliers/store'
import categories from '@modules/Product/Categories/store'
import customers from '@modules/Customer/Customers/store'
import userPhones from '@modules/User/UserPhones/store'
import supplierWorkers from '@modules/Supplier/SupplierWorkers/store'
import userDepartments from '@modules/User/UserDepartments/store'
import currencies from '@modules/Accounting/Currencies/store'
import chequeBooks from '@modules/Accounting/ChequeBooks/store'
import cheques from '@modules/Accounting/Cheques/store'
import checkouts from '@modules/Accounting/Checkouts/store'
import dashboard from '@modules/Dashboard/store'
import blockedBalances from '@modules/Accounting/BlockedBalances/store'
import banks from '@modules/Accounting/Banks/store'
import bankAccounts from '@modules/Accounting/BankAccounts/store'
import myBankAccounts from '@modules/Accounting/MyBankAccounts/store'
import exchangeRates from '@modules/Accounting/ExchangeRates/store'
import transactions from '@modules/Accounting/Transactions/store'
import myTransactions from '@modules/Accounting/MyTransactions/store'
import baseCurrencies from '@modules/Accounting/BaseCurrencies/store'
import balanceLimits from '@modules/Accounting/BalanceLimits/store'
import balance from '@modules/Accounting/Balance/store'
import taxes from '@modules/Product/Taxes/store'
import productUnits from '@modules/Product/ProductUnits/store'
import taxOffices from '@modules/Accounting/TaxOffices/store'
import prefixes from '@modules/Prefixes/store'
import userCodes from '@modules/User/UserCodes/store'
import documents from '@modules/Document/Documents/store'
import documentProperties from '@modules/Document/DocumentProperties/store'
import documentCategories from '@modules/Document/DocumentCategories/store'
import warehouses from '@modules/Warehouse/Warehouses/store'
import deliveryReceipts from '@modules/Warehouse/DeliveryReceipts/store'
import payments from '@modules/Warehouse/Payments/store'
import reports from '@modules/Accounting/Reports/store'
import expenses from '@modules/Accounting/Expenses/store'
import packages from '@modules/Packages/store'

const rootReducer = {
    auth,
    navbar,
    layout,
    location,
    users,
    roles,
    notifications,
    permissions,
    accountSettings,
    departments,
    settings,
    products,
    properties,
    suppliers,
    supplierWorkers,
    categories,
    customers,
    userPhones,
    userDepartments,
    currencies,
    chequeBooks,
    cheques,
    checkouts,
    dashboard,
    blockedBalances,
    banks,
    bankAccounts,
    myBankAccounts,
    exchangeRates,
    transactions,
    myTransactions,
    baseCurrencies,
    balanceLimits,
    balance,
    taxes,
    productUnits,
    taxOffices,
    prefixes,
    userCodes,
    documents,
    documentProperties,
    documentCategories,
    warehouses,
    deliveryReceipts,
    payments,
    reports,
    expenses,
    packages
}

export default rootReducer
